import React from 'react';

const BookmarkIcon = ({ width = 18, height = 18, color = 'white', ...rest }, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      ref={ref}
      {...rest}>
      <path
        d="M17.4763 18.6667L12.1191 16.2444L6.762 18.6667V4.22222H17.4763M17.4763 2H6.762C6.19368 2 5.64863 2.23413 5.24677 2.65087C4.84491 3.06762 4.61914 3.63285 4.61914 4.22222V22L12.1191 18.6667L19.6191 22V4.22222C19.6191 3.63285 19.3934 3.06762 18.9915 2.65087C18.5896 2.23413 18.0446 2 17.4763 2Z"
        fill={color}
      />
    </svg>
  );
};

export default React.forwardRef(BookmarkIcon);
